import { IoMdRadioButtonOff, IoMdRadioButtonOn } from "react-icons/io"
import PhoneInput from "react-phone-input-2"

export default function MentorQualificationApplication({ setApplicationState, applicationPiece }) {
  return (
    <>
      <h5>Career Expertise & Qualifications</h5>
      <p>Tell us more about your professional expertise</p>
      <div className="intended-learners-wr mentor-deets">
        <div style={{ border: "1px solid #cacacc", padding: "24px",  }}>
          <h5>Highest educational qualification</h5>
          <input onChange={(e) => { setApplicationState(prev => ({ ...prev, mentor: { ...prev.mentor, qualifications: { ...prev.mentor.qualifications, educationalQualification: { ...prev.mentor.qualifications.educationalQualification, title: e.target.value } } } })) }} value={applicationPiece.qualifications.educationalQualification.title} placeholder="Example: Bachelor of Technology, Chartered Accountant" type="text" maxLength={160} />
        </div>

        <div style={{ border: "1px solid #cacacc", padding: "24px",  }}>
          <h5>Professional Title</h5>
          <input onChange={(e) => { setApplicationState(prev => ({ ...prev, mentor: { ...prev.mentor, qualifications: { ...prev.mentor.qualifications, currentProfessionalRole: { ...prev.mentor.qualifications.currentProfessionalRole, title: e.target.value } } } })) }} value={applicationPiece.qualifications.currentProfessionalRole.title} placeholder="Example: Professor, IT Professional" type="text" maxLength={160} />
        </div>

        <div style={{ border: "1px solid #cacacc", padding: "24px",  }}>
          <h5>Work Experience (Months)</h5>
          <input onChange={(e) => { setApplicationState(prev => ({ ...prev, mentor: { ...prev.mentor, qualifications: { ...prev.mentor.qualifications, workExperience: Number(e.target.value) } } })) }} value={applicationPiece.qualifications.workExperience} placeholder="Work Experience in Months" type="number" max={720} />
        </div>

        <div style={{ border: "1px solid #cacacc", padding: "24px",  }}>
          <h5>Upload your resume</h5>
          <input onChange={(e) => { setApplicationState(prev => ({ ...prev, mentor: { ...prev.mentor, qualifications: { ...prev.mentor.qualifications, currentProfessionalRole: { ...prev.mentor.qualifications.currentProfessionalRole, resume: e.target.files[0] } } } })) }} placeholder="Work Experience in Months" type="file" />
        </div>

      </div>
      <h5>Have you previously worked with any LMS platforms?</h5>
      <p>This ensures we give you the proper guidance to get started on our platform</p>
      <div className="intended-learners-wr">
        <div className="intended-learners-wr-inner" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", width:"500px" }}>

          <label 
            style={{ background: applicationPiece.qualifications.previouslyWorkedWithLMS === true && "#f7f8fe", border: applicationPiece.qualifications.previouslyWorkedWithLMS === true && "3px solid black" }} 
            onClick={() => { setApplicationState(prev => ({ ...prev, mentor: { ...prev.mentor, qualifications: { ...prev.mentor.qualifications, previouslyWorkedWithLMS: true } } })) }} 
            className="custom-radio-label" for="id--580">
            <input type="radio" id="id--580" style={{ position: 'absolute' }} />
            {applicationPiece.qualifications.previouslyWorkedWithLMS === true ? <IoMdRadioButtonOn style={{ color: "#000" }} size={24} /> : <IoMdRadioButtonOff size={24} style={{ color: "#000" }} />}
            <div>Yes</div>
          </label>

          <label 
            style={{ background: applicationPiece.qualifications.previouslyWorkedWithLMS === false && "#f7f8fe", border: applicationPiece.qualifications.previouslyWorkedWithLMS === false && "3px solid black" }} 
            onClick={() => { setApplicationState(prev => ({ ...prev, mentor: { ...prev.mentor, qualifications: { ...prev.mentor.qualifications, previouslyWorkedWithLMS: false } } })) }} 
            className="custom-radio-label" for="id--581">
            <input type="radio" id="id--581" style={{ position: 'absolute' }} />
            {applicationPiece.qualifications.previouslyWorkedWithLMS === false ? <IoMdRadioButtonOn style={{ color: "#000" }} size={24} /> : <IoMdRadioButtonOff size={24} style={{ color: "#000" }} />}
            <div>No</div>
          </label>
        </div>
      </div>
    </>
  )
}